<template>
  <el-dialog
    :title="title"
    :custom-class="customClass"
    :visible.sync="dialogVisible"
    :width="`${currentWidth}%`"
    append-to-body
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    :before-close="beforeClose"
    v-dialogDrag
  >
    <!-- <myScroll> -->
      <slot />
    <!-- </myScroll> -->
    <span slot="footer" class="dialog-footer" v-if="showFooter">
      <el-button size="" v-if="showSubBtn" type="primary" :loading="btnLoading" @click="submit(2)">{{submitTxt}}</el-button>
      <el-button size="" v-if="showCloseBtn" @click="submit(1)">{{closeTxt}}</el-button>
      <el-button size="" v-if="showCancelBtn" type="danger" :loading="cancelbtnLoading" @click="submit(3)">{{cancelTxt}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return "提示";
      }
    },
    currentWidth: {
      type: Number,
      default() {
        return 45;
      }
    },
    showFooter: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showSubBtn: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showCancelBtn: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showCloseBtn: {
      type: Boolean,
      default() {
        return false;
      }
    },
    formName: {
      type: String,
      default() {
        return "";
      }
    },
    customClass: {
      type: String,
      default() {
        return "";
      }
    },
    dialogVisible: {
      type: Boolean,
      default() {
        return true;
      }
    },
    closeTxt: {
      type: String,
      default() {
        return "取 消";
      }
    },
    submitTxt: {
      type: String,
      default() {
        return "确 定";
      }
    },
    cancelTxt: {
      type: String,
      default() {
        return "取 消";
      }
    },
  },
  data() {
    return {
      btnLoading: false,
      cancelbtnLoading: false
    };
  },
  methods: {
    submit(value) {
      // console.log("value1", value);
      if (value === 1) {
        this.$emit("closeDialog", value);
      } else {
        if (!this.formName) {
          if(value == 3){
            this.cancelbtnLoading = true;
          }else{
            this.btnLoading = true;
          }
          this.$emit("closeDialog", value);
          setTimeout(() => {
            if(value == 3){
              this.cancelbtnLoading = false;
            }else{
              this.btnLoading = false;
            }
          }, 2000);
        } else {
          this.$parent.$refs[this.formName].validate(valid => {
            if (valid) {
              if(value == 3){
                this.cancelbtnLoading = false;
              }else{
                this.btnLoading = false;
              }
              setTimeout(() => {
                if(value == 3){
                  this.cancelbtnLoading = true;
                }else{
                  this.btnLoading = true;
                }
              }, 2000);
              this.$emit("closeDialog", value);
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        }
      }
    },
    beforeClose() {
      this.$emit("closeDialog", 1);
    }
  }
};
</script>

<style>
.el-dialog__body {
  /* text-align: center; */
}
</style>
